import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";

import { IGivenOnRentProperties } from "../../../../config/interfaces";
import { useAppDispatch } from "../../../../redux/Store";
import { showHintModal } from "../../../../redux/slice/HintModalSlice";
import FASvgIcon from "../../../FASvgIcon";
import { FormField, NumericInputField } from "../../../fields";

type Props = {};

const RIIncomeDetailsForm: React.FC<Props> = (props: Props) => {
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<IGivenOnRentProperties>();

  const dispatch = useAppDispatch();
  const ownerShare: number = Number(values.OwnerDetails[0].Percentage) / 100;

  useEffect(() => {
    getNetIncome(values.TotalAnnualRentReceived, values.MunicipalTax);
  }, [values.OwnerDetails]);

  const getNetIncome = (value1: string, value2: string) => {
    const netIncome = Number(value1 || 0) * ownerShare - Number(value2 || 0) * ownerShare;
    setFieldValue("NetIncome", netIncome);
    const netIncome30Per = netIncome * 0.3;
    setFieldValue("StandardDeductionUs24A", netIncome30Per);

    // Net Taxable Income
    setFieldValue("NetTaxableIncome", netIncome - Number(values?.TotalDeduction || 0));
  };

  return (
    <>
      <section className="mb-5">
        <Card className="more-info-card shadow-none">
          <Card.Header>
            <Card.Title>Income Details</Card.Title>
          </Card.Header>
          <Card.Body>
            <section>
              <FormField label="A. Annual Rent Received by you" sm={6}>
                <NumericInputField
                  showLeftIcon={true}
                  name="TotalAnnualRentReceived"
                  value={values.TotalAnnualRentReceived}
                  onBlur={handleBlur("TotalAnnualRentReceived")}
                  onChange={(value) => {
                    setFieldValue("TotalAnnualRentReceived", value);
                    getNetIncome(value, values.MunicipalTax);
                  }}
                  isInvalid={
                    Boolean(errors.TotalAnnualRentReceived) && touched.TotalAnnualRentReceived
                  }
                  errorMsg={errors.TotalAnnualRentReceived}
                />
              </FormField>

              <FormField
                label={
                  <>
                    B. Tax Paid to municipal authorities
                    <span
                      className="info-wrap"
                      role="button"
                      onClick={() => {
                        dispatch(
                          showHintModal({
                            title: "Municipal Tax",
                            componentName: "MunicipalTaxHint"
                          })
                        );
                      }}
                    >
                      <FASvgIcon icon={faInfoCircle} />
                    </span>
                  </>
                }
                sm={6}
              >
                <NumericInputField
                  showLeftIcon={true}
                  name="MunicipalTax"
                  value={values.MunicipalTax}
                  onBlur={handleBlur("MunicipalTax")}
                  onChange={(value) => {
                    setFieldValue("MunicipalTax", value);
                    getNetIncome(values.TotalAnnualRentReceived, value);
                  }}
                  isInvalid={Boolean(errors.MunicipalTax) && touched.MunicipalTax}
                  errorMsg={errors.MunicipalTax}
                  note="Specifying Municipal Tax you paid reduces your tax liability"
                />
              </FormField>

              <FormField label="C. Annual Value" sm={6}>
                <NumericInputField
                  showLeftIcon={true}
                  name="NetIncome"
                  value={values.NetIncome}
                  onBlur={handleBlur("NetIncome")}
                  onChange={(value) => setFieldValue("NetIncome", value)}
                  isInvalid={Boolean(errors.NetIncome) && touched.NetIncome}
                  errorMsg={errors.NetIncome}
                  isDisabled={true}
                />
              </FormField>
            </section>
          </Card.Body>
        </Card>
      </section>
    </>
  );
};

export default RIIncomeDetailsForm;
